import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

export const parseNum = (v) => {
  const s = String(v ?? "").trim().replace(/\s/g, "");
  if (!s) return "";
  const t = s.includes(",") ? s.replace(/\./g, "").replace(",", ".") : s;
  return Number.isFinite(Number(t)) ? t : "";
};

// Text input that accepts "2,968" or "2.968"; onChange receives e.target.value normalized with a dot.
export const NumInput = ({ value, onChange, ...props }) => {
  const [raw, setRaw] = useState(value == null ? "" : String(value).replace(".", ","));
  useEffect(() => { if (parseNum(raw) !== String(value ?? "")) setRaw(value == null ? "" : String(value).replace(".", ",")); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const handle = (e) => {
    const v = e.target.value;
    if (!/^[\d.,\s-]*$/.test(v)) return;
    setRaw(v);
    onChange({ target: { value: parseNum(v) } });
  };
  return <Input type="text" inputMode="decimal" {...props} value={raw} onChange={handle} />;
};
